import {isNumber} from 'lodash'
import {DateTime} from 'luxon'

/**
 * timestamp to yyyy.MM.dd
 * @example 1576491398263 to 2019.12.16
 * @param value
 * @param format
 */
export default (value?: number, format: string = 'yyyy. MM. dd') => {
  if(!isNumber(value)) {
    return ''
  }
  return DateTime.fromMillis(value).toFormat(format)
}
